<template>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" title="当前登录账号信息">
        <table class="QHtable" v-if="show">
            <tr>
                <td style="width:125px;"><b>员工姓名</b></td>
                <td>{{ row.cityteamUserName }}</td>
            </tr>
            <tr>
                <td><b>登录账号</b></td>
                <td>{{ row.cityteamUserAccount }}</td>
            </tr>
            <tr>
                <td><b>所属单位</b></td>
                <td>{{ row.cityteamName }}</td>
            </tr>
            <tr>
                <td><b>账号角色</b></td>
                <td>
                    <tag color="cyan" v-for="(item, index) in row.roleList" :key="index">
                        {{ item.title }}
                    </tag>
                </td>
            </tr>
        </table>
    </Modal>
</template>



<script>
export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            show: false,
            row: {}
        }
    },
    methods: {
        // +----------------------------------------------------------------------
        // | Desc:唤起修改
        // +----------------------------------------------------------------------
        hiPop() {
            //参数整合与接口
            var that = this;
            var https = {
                type: 'isRow',
                api: this.$api.getNowUserGobal
            };
            this.$httpsApi(https, function (res) {
                that.show = true;
            });
        }
    }
};
</script>